import { render, staticRenderFns } from "./SunsetPointsInput.vue?vue&type=template&id=1cea9259&scoped=true"
import script from "./SunsetPointsInput.vue?vue&type=script&lang=js"
export * from "./SunsetPointsInput.vue?vue&type=script&lang=js"
import style0 from "./SunsetPointsInput.vue?vue&type=style&index=0&id=1cea9259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cea9259",
  null
  
)

export default component.exports